import {User} from "../../objects/users/user";
import {Group} from "../../objects/groups/group";
/**
 * Created by vlad.p on 8/4/2017.
 */

export class UserHelper {

    public static isInGroup(user: User, group: Group): boolean {
        return this.isInGroupById(user,group.Id);
    }

    public static isInGroupById(user: User, groupId: number): boolean {
        if (user.Groups == null || user.Groups.length == 0)
            return false;

        return user.Groups.find(x => x.Id == groupId) != null;
    }

    public static getCommaSeparatedGroups(user: User): string {
        if (user == null || user.Groups == null || user.Groups.length == 0)
            return 'No Groups.';

        let result = user.Groups[0].Name;

        for(let i = 1; i< user.Groups.length; i++) {
            result += ', ' + user.Groups[i].Name;
        }

        return result;
    }

}


// WEBPACK FOOTER //
// ./app/common/helpers/userHelper.ts